var map = {
	"./competition_0_1/cabbage.png": "./src/TaskWindows/StripesApp/img/picture/competition_0_1/cabbage.png",
	"./competition_0_1/goat.png": "./src/TaskWindows/StripesApp/img/picture/competition_0_1/goat.png",
	"./competition_0_1/wolf.png": "./src/TaskWindows/StripesApp/img/picture/competition_0_1/wolf.png",
	"./default/african_girl.svg": "./src/TaskWindows/StripesApp/img/picture/default/african_girl.svg",
	"./default/eskimos.svg": "./src/TaskWindows/StripesApp/img/picture/default/eskimos.svg",
	"./default/ice.svg": "./src/TaskWindows/StripesApp/img/picture/default/ice.svg",
	"./default/nest.svg": "./src/TaskWindows/StripesApp/img/picture/default/nest.svg",
	"./default/seal.svg": "./src/TaskWindows/StripesApp/img/picture/default/seal.svg",
	"./devices/cam.png": "./src/TaskWindows/StripesApp/img/picture/devices/cam.png",
	"./devices/cooler.png": "./src/TaskWindows/StripesApp/img/picture/devices/cooler.png",
	"./devices/cpu.png": "./src/TaskWindows/StripesApp/img/picture/devices/cpu.png",
	"./devices/keyboard.png": "./src/TaskWindows/StripesApp/img/picture/devices/keyboard.png",
	"./devices/memory.png": "./src/TaskWindows/StripesApp/img/picture/devices/memory.png",
	"./devices/mic.png": "./src/TaskWindows/StripesApp/img/picture/devices/mic.png",
	"./devices/monitor_pc.png": "./src/TaskWindows/StripesApp/img/picture/devices/monitor_pc.png",
	"./devices/mouse.png": "./src/TaskWindows/StripesApp/img/picture/devices/mouse.png",
	"./devices/oak.svg": "./src/TaskWindows/StripesApp/img/picture/devices/oak.svg",
	"./devices/printer.png": "./src/TaskWindows/StripesApp/img/picture/devices/printer.png",
	"./devices/ram.png": "./src/TaskWindows/StripesApp/img/picture/devices/ram.png",
	"./rules/back.png": "./src/TaskWindows/StripesApp/img/picture/rules/back.png",
	"./rules/dino.png": "./src/TaskWindows/StripesApp/img/picture/rules/dino.png",
	"./rules/fingers.png": "./src/TaskWindows/StripesApp/img/picture/rules/fingers.png",
	"./rules/food.png": "./src/TaskWindows/StripesApp/img/picture/rules/food.png",
	"./rules/monitor_rule.png": "./src/TaskWindows/StripesApp/img/picture/rules/monitor_rule.png",
	"./rules/rest.png": "./src/TaskWindows/StripesApp/img/picture/rules/rest.png",
	"./rules/socket.png": "./src/TaskWindows/StripesApp/img/picture/rules/socket.png",
	"./rules/start.png": "./src/TaskWindows/StripesApp/img/picture/rules/start.png",
	"./rules/window.png": "./src/TaskWindows/StripesApp/img/picture/rules/window.png",
	"./rules/wires.png": "./src/TaskWindows/StripesApp/img/picture/rules/wires.png",
	"./year3_lesson7/acorns.png": "./src/TaskWindows/StripesApp/img/picture/year3_lesson7/acorns.png",
	"./year3_lesson7/bumps.png": "./src/TaskWindows/StripesApp/img/picture/year3_lesson7/bumps.png",
	"./year3_lesson7/nectar.png": "./src/TaskWindows/StripesApp/img/picture/year3_lesson7/nectar.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/TaskWindows/StripesApp/img/picture sync recursive \\.(png%7Csvg)$";